<div class="document" detect-scroll>
    <br />

    <p class="s lastUpdated"><span class="bold">Last updated:</span> May 2023</p>

    <p class="s">
        <span class="bold">Aptoide Connect</span> is a software developed by Aptoide S.A. (“Aptoide”), a company with ID 509987184 and principal place of business at Rua Soeiro Pereira Gomes, Lote 1,
        3D, 1649-031 Lisboa, and its registered office at Rua Fernanda Seno n. 6, 7005-484, Évora, Portugal, which allows the distribution of products in the Aptoide App Store and other Apps
        distribution channels.
    </p>

    <p class="s">
        As used in these Terms and Conditions, "we" and "us" means Aptoide, and “you” and “user” means the person who accesses to Aptoide Connect and uses the services provided by Aptoide to
        distribute Apps.
    </p>

    <p class="s">
        Before using Aptoide Connect, please read these Terms and Conditions, together with any other policies or notices made available by Aptoide Connect and our Privacy Policy (together referred to
        as the “Terms”).
    </p>

    <p class="s">If you do not agree with the Terms, you should not use, or cease to use, Aptoide Connect.</p>

    <h4>1. General</h4>

    <p class="s">Aptoide Connect is a SaaS (Software as a Service) developed for professionals which allows the distribution of Apps.</p>
    <p class="s">
        In order to have access to Aptoide Connect services you must first enter into a distribution or partnership agreement with Aptoide, which will detail the terms and conditions applicable to the
        Aptoide Connect services which will be provided to you (the “Agreement”).
    </p>
    <p class="s">By using Aptoide Connect, you acknowledge that you have read, understood and agreed to the Terms.</p>
    <p class="s">
        When agreeing with these Terms, the user declares that, by accessing the Services, has the legal age and/or legal capacity to, according to the law, provide consent and be contractually bound
        in the execution and provision of the Services.
    </p>
    <p class="s">You agree to use Aptoide Connect only for purposes that are permitted by the Terms and the Agreement.</p>
    <p class="s">
        You agree that you will not violate any laws when using Aptoide Connect. This includes any local, provincial, state, federal, national, or international laws that may apply to you.
    </p>
    <p class="s">You agree that you will not engage in any activity that interferes with or disrupts Aptoide Connect (or the servers and networks which are connected to the protocol).</p>
    <p class="s">
        You agree that you are solely responsible for (and that Aptoide has no responsibility to you or to any third party for) any breach of your obligations under the Terms and for the consequences
        (including any loss or damage) of any such breach.
    </p>

    <h4>2. Services</h4>

    <p class="s">Aptoide Connect is a software developed for professionals to allow the distribution of Apps in different distribution channels.</p>

    <p class="s">
        By registering in Aptoide Connect, or when you log-in for the first time in Aptoide Connect with your credentials, a Wallet will automatically be added to your account(Wallet Account). All
        transactions made through Aptoide Connect will be managed by such Wallet Account.
    </p>

    <p class="s">Aptoide Connect will allow you to:</p>
    <ol type="a">
        <li class="s thin">Distribute your Apps in Aptoide App Store and other Partner App Stores.</li>
        <li class="s thin">Sell In-App Products to end users and receive a revenue share.</li>
    </ol>

    <h4>3. Aptoide Connect Fee</h4>

    <p class="s">
        In consideration for the use of the Services, you undertake to pay to Aptoide an annual fee. The amount of the annual fee is determined by Aptoide and is available in your account. Aptoide
        Connect fee is refundable in the first 30 days and before any of your Apps starts to be distributed in Aptoide Connect.
    </p>
    <p class="s">
        The annual fee is due when you first subscribe to Aptoide Connect Services and will be due every subsequent year on the same date. Payment of the annual fee may be performed through your
        Certified Developer Account by using your credit card, PayPal account or other available payment methods.
    </p>
    <p class="s">By paying the annual fee you will have immediate access to the Services.</p>

    <h4>4. Restricted Content</h4>

    <p class="s">Apps and other materials made available while using the Services (“Content”) must comply with the following:</p>
    <ol type="a">
        <li class="s thin">
            Sexual Content: Content cannot contain or promote sexual content or profanity, including pornography, or any content or services intended to be sexually gratifying. Content that contains
            nudity may be allowed if the primary purpose is educational, documentary, scientific or artistic, and is not gratuitous.
        </li>
        <li class="s thin">
            Child Endangerment: Content that sexualizes minors, including but not limited to, Content that promotes paedophilia or inappropriate interaction targeted at a minor (e.g. groping or
            caressing) is not allowed.
        </li>
        <li class="s thin">
            Hate Speech: Content cannot promote violence or incite hatred against individuals or groups based on race or ethnic origin, religion, disability, age, nationality, veteran status, sexual
            orientation, gender, gender identity, or any other characteristic that is associated with systemic discrimination or marginalization.
        </li>
        <li class="s thin">
            Violence: Content cannot depict or facilitate gratuitous violence or other dangerous activities nor be related to terrorism, such as content that promotes terrorist acts, incites violence,
            or celebrates terrorist attacks. Content that depict fictional violence in the context of a game, such as cartoons, hunting or fishing, are generally allowed.
        </li>
        <li class="s thin">
            Dangerous Products: Content cannot facilitate the sale of explosives, firearms, ammunition, or certain firearms accessories or instructions for the manufacture of explosives, firearms,
            ammunition, restricted firearm accessories, or other weapons.
        </li>
        <li class="s thin">Alcohol, tobacco and drugs: Content cannot facilitate the sale alcohol, tobacco or drugs or encourage the illegal or inappropriate use of alcohol or tobacco.</li>
        <li class="s thin">Financial Services: Content cannot expose users to deceptive or harmful financial products and services.</li>
        <li class="s thin">
            Gambling: Content and services that facilitate online gambling may be allowed to be distributed in certain locations and if it meets certain requirements which are analysed on a
            case-by-case basis and subject to applicable laws and other criteria.
        </li>
        <li class="s thin">Illegal activities: Content cannot promote or facilitate illegal activities.</li>
        <li class="s thin">
            Intellectual Property: Content cannot violate intellectual property rights, including patent, copyright, trademark, trade secret, or other proprietary right of any party or encourage or
            induce infringement of intellectual property rights.
        </li>
        <li class="s thin">Privacy: Content must comply with all applicable local laws, the European Union’s General Data Protection Regulation (GDPR).</li>
    </ol>

    <p class="s">You also undertake not to upload or otherwise make available Apps or any other materials that:</p>
    <ol type="a">
        <li class="s thin">
            contain viruses, trojans, spyware, adware, ransomware, rootkits, back doors, worms and any other malware or any similar mechanism or device, or any other code designed or intended to have,
            or intended to be capable of performing, any of the following functions: (a) disrupting, disabling, harming, or otherwise impeding in any manner the access to or the operation of, or
            providing unauthorized access to, a computer system or network or other device on which such code is stored or installed; or (b) accessing, copying, blocking, encrypting, damaging or
            destroying any data or file, in each case, without the user’s consent.
        </li>
        <li class="s thin">harm user devices or personal data.</li>
        <li class="s thin">create unpredictable network usage that has an adverse impact on a user's service charges or an Authorized Carrier's network.</li>
        <li class="s thin">knowingly violate an Authorized Carrier's terms of service for allowed usage.</li>
        <li class="s thin">create a spammy user experience, whether by posting repetitive content or misleading information about an App's purpose.</li>
    </ol>

    <p class="s">
        In case Aptoide detects Content that does not comply with these Terms, Aptoide may, without prejudice of Aptoide’s rights to terminate any agreement with you, remove or disable access to such
        Content.
    </p>
    <p class="s">
        We may report any activity that we suspect violates any law or regulation to appropriate law enforcement officials, regulators, or other appropriate third parties. Our reporting may include
        disclosing appropriate user information. We also may cooperate with appropriate law enforcement agencies, regulators, or other appropriate third parties to help with the investigation and
        prosecution of illegal conduct related to alleged violations of these Terms.
    </p>

    <h4>5. Third Party Services</h4>

    <p class="s">
        In using Aptoide Connect you may view content or utilize services provided by third parties, including hyperlinks to other web sites or content or resources (“Third-Party Content”).
    </p>

    <p class="s">
        Sometimes when you use the Third-Party Content, you may use a service or download a piece of software which are provided by another person or company. Your use of these other services,
        software or goods may be subject to separate terms between you and the company or person concerned. If so, the Terms do not affect your legal relationship with these other companies or
        individuals.
    </p>
    <p class="s">
        You acknowledge and agree that Aptoide is not responsible for the availability of any such external sites or resources, and does not control, endorse or adopt any advertising, products or
        other materials on or available from such web sites or resources.
    </p>
    <p class="s">
        Users who conduct transactions or take part in other activities through the Third-Party Content do so at their own risk. You acknowledge and agree that Aptoide is not liable for any loss or
        damage which may be incurred by you as a result of the availability of those external sites or resources, or as a result of any reliance placed by you on the completeness, accuracy or
        existence of any advertising, products or other materials on, or available from, such websites or resources.
    </p>

    <h4>6. Proprietary Rights</h4>

    <p class="s">
        You acknowledge and agree that Aptoide (or Aptoide licensors) own all legal right, title and interest in and to Aptoide Connect and its related components, including any intellectual property
        rights which subsist in Aptoide Connect (whether those rights happen to be registered or not, and wherever in the world those rights may exist).
    </p>

    <p class="s">Nothing in the Terms gives you a right to use any of Aptoide’s trade names, trademarks, service marks, logos, domain names, and other distinctive brand features.</p>

    <h4>7. Intellectual Property</h4>

    <p class="s">
        Aptoide Connect contains copyright material which is protected by intellectual property rights. You acknowledge that the property and title for all the rights of intellectual property,
        including the rights for the software, codes, copyrights, trademarks and commercial secrets, are and shall remain the property of Aptoide (or its licensors).
    </p>

    <p class="s">
        In the same way, the workflow processes, user interface, designs, know-how and other technologies provided by Aptoide as part of the Services, as well as all the rights, titles and interests
        related to them, including all associated intellectual property rights, are Aptoide’s property.
    </p>

    <p class="s">Aptoide grants, within the reasonable knowledge that it has, that it will not violate the intellectual property rights of third parties.</p>
    <p class="s">
        All the rights not expressly provided for and listed in this Clause are reserved to Aptoide and cannot be interpreted in any other way at any time, and, in case of doubt, shall always be
        interpreted as meaning that the use, in case of doubt, is expressly prohibited by Aptoide.
    </p>
    <p class="s">The following actions are expressly prohibited to the user:</p>
    <ol type="a">
        <li class="s thin">Copy, translate, disassemble decompile, attempt to reverse-engineer or otherwise create the source code and/or objects or tools included in the Services;</li>
        <li class="s thin">Removal of any kind of confidentiality or property warning;</li>
        <li class="s thin">Sell, resell, redistribute, sublicense or rent the Services, unless an agreement with Aptoide says the opposite;</li>
        <li class="s thin">Use the Services to store or transmit illegal content;</li>
        <li class="s thin">Use the Services to store or transmit content that violates third-parties’ rights;</li>
        <li class="s thin">Interfere with or disrupt the integrity or performance of the Services;</li>
        <li class="s thin">Seek unauthorized access to the Services and/or Aptoide’s computer systems;</li>
        <li class="s thin">Decompile, disassemble or reverse engineer the Services;</li>
        <li class="s thin">Seek to obtain the source code, modify, decrypt, or create derivative works of the Services provided under these Terms;</li>
        <li class="s thin">Access or use the Services to build a competing product and/or service or copy any feature or graphic for competing purposes.</li>
    </ol>
    <p class="s">If you breach any of the provisions above, Aptoide has the right to immediately terminate any Agreement entered with you and to suspend your access to the Services.</p>

    <h4>8. Exclusion of Warranties</h4>

    <p class="s">
        NOTHING IN THESE TERMS SHALL EXCLUDE OR LIMIT WALLID’S WARRANTY OR LIABILITY FOR LOSSES WHICH MAY NOT BE LAWFULLY EXCLUDED OR LIMITED BY APPLICABLE LAW. SOME JURISDICTIONS DO NOT ALLOW THE
        EXCLUSION OF CERTAIN WARRANTIES OR CONDITIONS OR THE LIMITATION OR EXCLUSION OF LIABILITY FOR LOSS OR DAMAGE CAUSED BY NEGLIGENCE, BREACH OF CONTRACT OR BREACH OF IMPLIED TERMS, OR INCIDENTAL
        OR CONSEQUENTIAL DAMAGES. ACCORDINGLY, ONLY THE LIMITATIONS WHICH ARE LAWFUL IN YOUR JURISDICTION WILL APPLY TO YOU AND OUR LIABILITY WILL BE LIMITED TO THE MAXIMUM EXTENT PERMITTED BY LAW.
    </p>
    <p class="s">
        YOU EXPRESSLY UNDERSTAND AND AGREE THAT YOUR USE OF OS THE SERVICES IS AT YOUR SOLE RISK AND THAT STOREID IS PROVIDED ON AN "AS IS" AND “AS AVAILABLE.” WITHOUT ANY REPRESENTATION OR WARRANTY,
        WHETHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO THE IMPLIED WARRANTIES AND CONDITIONS OF TITLE, MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT. WE DO NOT MAKE
        ANY REPRESENTATIONS OR WARRANTIES THAT ACCESS TO THE SERVICES WILL BE CONTINUOUS, UNINTERRUPTED, TIMELY OR ERROR-FREE.
    </p>

    <p class="s">IN PARTICULAR, WALLID, ITS SUBSIDIARIES AND AFFILIATES, AND ITS LICENSORS DO NOT REPRESENT OR WARRANT TO YOU THAT:</p>
    <ol type="a">
        <li class="s thin">YOUR USE OF THE SERVICES WILL MEET YOUR REQUIREMENTS,</li>
        <li class="s thin">YOUR USE OF THE SERVICES WILL BE UNINTERRUPTED, TIMELY, SECURE OR FREE FROM ERROR,</li>
        <li class="s thin">ANY INFORMATION OBTAINED BY YOU AS A RESULT OF YOUR USE OF THE SERVICES WILL BE ACCURATE OR RELIABLE, AND</li>
        <li class="s thin">DEFECTS IN THE OPERATION OR FUNCTIONALITY OF ANY SOFTWARE PROVIDED TO YOU AS PART OF THE SERVICES WILL BE CORRECTED.</li>
    </ol>

    <h4>9.Limitation of Liability</h4>

    <p class="s">
        TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT WILL APTOIDE, ITS SUBSIDIARIES AND AFFILIATES, AND ITS LICENSORS BE LIABLE TO YOU UNDER CONTRACT, STRICT LIABILITY, NEGLIGENCE,
        OR ANY OTHER LEGAL OR EQUITABLE THEORY, FOR ANY LOST PROFITS, DATA LOSS, COST OF PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES, OR DIRECT, INDIRECT, INCIDENTAL, SPECIAL, PUNITIVE, COMPENSATORY,
        OR CONSEQUENTIAL DAMAGES OF ANY KIND WHATSOEVER RESULTING FROM:
    </p>
    <ol type="a">
        <li class="s thin">YOUR USE OF, OR CONDUCT IN CONNECTION WITH, THE SERVICES;</li>
        <li class="s thin">ANY UNAUTHORIZED USE OF YOUR WALLET ADDRESS AND/OR PRIVATE KEY DUE TO YOUR FAILURE TO MAINTAIN THE CONFIDENTIALITY OF YOUR WALLET ACCOUNT;</li>
        <li class="s thin">ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM THE SERVICES;</li>
        <li class="s thin">
            ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE THAT ARE FOUND IN THE SOFTWARE OR THAT MAY BE TRANSMITTED TO OR THROUGH THE SERVICES BY ANY THIRD PARTY (REGARDLESS OF THE SOURCE OF
            ORIGINATION);
        </li>
        <li class="s thin">ANY CHANGES WHICH APTOIDE MAY MAKE TO THE SERVICES, OR FOR ANY PERMANENT OR TEMPORARY CESSATION IN THE PROVISION OF THE SERVICES (OR ANY FEATURES WITHIN STOREID).</li>
    </ol>

    <p class="s">
        THE LIMITATIONS ON APTOIDE’S LIABILITY TO YOU SHALL APPLY WHETHER OR NOT APTOIDE HAS BEEN ADVISED OF OR SHOULD HAVE BEEN AWARE OF THE POSSIBILITY OR THE ARISING OF ANY SUCH LOSSES.
    </p>

    <h4>10. Data Protection</h4>

    <p class="s">The processing of personal data is governed by Aptoide’s Privacy Policy, which is available here and that should be consulted for this purpose.</p>
    <p class="s">You commit not to use software tools to collect personal data, such as robots, crawlers or other automatic mechanisms.</p>

    <h4>11. Support and Maintenance Services</h4>
    <p class="s">Aptoide ensures that the Services will be up to date, and that any updates will result from the maintenance services automatically provided by Aptoide, as programmed by Aptoide.</p>
    <p class="s">
        Aptoide will employ its best efforts for a continuous availability to the Services, but cannot guarantee that it will occur, which the user accepts, waiving at any compensation due to the
        absence of availability.
    </p>
    <p class="s">The user accepts and acknowledges that performance and availability issues may occur as a cause and/or origin:</p>

    <ol type="a">
        <li class="s thin">Internet congestion, slowdown or general unavailability;</li>
        <li class="s thin">Unavailability of generic internet services (DNS servers) due to external attacks;</li>
        <li class="s thin">
            Major force events (unpredictable and unavoidable event, unrelated to the control of the parties, which prevents, totally or partially, permanently or temporarily, from achieving their
            objectives and fulfilling their obligations on the contractual dates and deadlines such as state of war, declared or not, rebellions or riots, natural disasters such as fires, floods or
            earthquakes and communications cuts);
        </li>
        <li class="s thin">Actions or omissions of the user or third parties which are not under control of Aptoide;</li>
        <li class="s thin">As a result of the computer system of the user or third parties;</li>
        <li class="s thin">The maintenance of the Services programmed by Aptoide, as well as updates that may occur.</li>
    </ol>

    <h4>12. Amendment of the Terms</h4>

    <p class="s">
        The entry into force of new policies after the date of the Terms, will result in the amendment of the Terms through their integration. In case of contradiction or non-conformity between
        documents that integrate the Terms, these prevail over the policies. In any case, the specific Agreement entered into with Aptoide will prevail over these Terms and other policies.
    </p>
    <p class="s">Aptoide can, at any moment, update, modify or replace any part of the Terms by publishing those changes in an accessible channel for the user.</p>
    <p class="s">
        The user acknowledges that the continued use and access to the Services after any updates, modifications or substitutions to the Terms constitutes acceptance and agreement with such updates,
        modifications or substitutions.
    </p>

    <h4>13. Severability</h4>

    <p class="s">
        If any provision of the Terms is declared unlawful, void or ineffective, such provision shall be replaced, in whole or in part, by another that is valid, so as to best reflect the terms of the
        Clause in question.
    </p>
    <p class="s">
        The user agrees to guarantee Aptoide’s position, and defend it, as well as its social bodies, employees, partners, agents, and service providers, from any claim or demand made by any third
        party due to or arising out their violation of the Terms, as well as the violation of any laws or third party rights.
    </p>
    <p class="s">
        The failure to require, at any time, user’s compliance with any of its contractual obligations, does not imply a waiver of any rights, nor does it constitute the acquisition of a right by the
        user.
    </p>
    <h4>14. Jurisdiction</h4>

    <p class="s">The Terms are governed by the Portuguese Law.</p>
    <p class="s">
        For the resolution of any litigation arising from the Terms, if not settled by agreement, exclusive jurisdiction is assigned to the District Court of Lisboa, expressly renouncing to any other,
        unless it overlaps by the virtue of law.
    </p>

    <br />
    <br />
</div>
